export const CARPETAS_REQUEST = 'CARPETAS_REQUEST'
export const CARPETAS_SUCCESS = 'CARPETAS_SUCCESS'
export const CARPETAS_ERROR = 'CARPETAS_ERROR'

export const DOCUMENTOS_REQUEST = 'DOCUMENTOS_REQUEST'
export const DOCUMENTOS_SUCCESS = 'DOCUMENTOS_SUCCESS'
export const DOCUMENTOS_ERROR = 'DOCUMENTOS_ERROR'